var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404IllustrationSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "540px",
    height: "297px",
    viewBox: "0 0 540 297",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.3865017%",
    y1: "6.63220176%",
    x2: "53.9409722%",
    y2: "57.4712549%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.4957682%",
    y1: "0%",
    x2: "43.5481771%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "42.7075447%",
    x2: "24.2768159%",
    y2: "56.9662867%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.304163,64 L144.304097,63.8411346 C140.603199,63.1053273 137.817676,59.900675 137.817676,56.0588235 C137.817676,51.6730329 141.4478,48.1176471 145.925784,48.1176471 C148.357827,48.1176471 150.539777,49.1663777 152.025911,50.8272937 C153.577457,48.2548518 156.437778,46.5294118 159.709568,46.5294118 L159.539357,46.5320382 C161.371499,41.0126222 166.925832,37 173.493352,37 C180.75041,37 186.770358,41.8994425 187.8982,48.317454 C188.480361,48.186421 189.086764,48.1176471 189.709568,48.1176471 C194.187553,48.1176471 197.817676,51.6730329 197.817676,56.0588235 C197.817676,56.0815133 197.817579,56.1041808 197.817385,56.1268257 C198.136764,56.0438225 198.472102,56 198.817676,56 C201.026815,56 202.817676,57.790861 202.817676,60 C202.817676,62.209139 201.026815,64 198.817676,64 C198.643623,64 198.472166,63.9888832 198.303977,63.9673208 L198.304163,64 L144.304163,64 Z M183.101055,60.660952 L182.922179,60.8048634 C182.91391,60.8113439 182.905633,60.817816 182.897347,60.8242798 L183.222722,60.8238341 C183.181481,60.7700654 183.140921,60.7157673 183.101055,60.660952 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.5%",
    y: "-20.4%",
    width: "116.9%",
    height: "140.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.764622%",
    y1: "42.8340925%",
    x2: "24.2768159%",
    y2: "56.845399%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.817676,51 C210.608537,51 208.817676,49.209139 208.817676,47 C208.817676,44.790861 210.608537,43 212.817676,43 C214.21132,43 215.4385,43.7127211 216.154606,44.7935553 C216.825316,43.1540312 218.436727,42 220.317676,42 L220.126836,42.0044728 C221.047318,39.1106857 223.918402,37 227.317676,37 C231.148691,37 234.308826,39.6808904 234.761935,43.1422696 C235.097472,43.0491126 235.451838,43 235.817676,43 C238.026815,43 239.817676,44.790861 239.817676,47 C239.817676,47.0924298 239.814541,47.1841273 239.808372,47.2749921 C240.103238,47.0998664 240.448795,47 240.817676,47 C241.922246,47 242.817676,47.8954305 242.817676,49 C242.817676,50.1045695 241.922246,51 240.817676,51 L240.817676,51 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.2%",
    y: "-39.3%",
    width: "132.4%",
    height: "178.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.817676,67 C398.608537,67 396.817676,65.209139 396.817676,63 C396.817676,60.790861 398.608537,59 400.817676,59 C402.21132,59 403.4385,59.7127211 404.154606,60.7935553 C404.825316,59.1540312 406.436727,58 408.317676,58 L408.126836,58.0044728 C409.047318,55.1106857 411.918402,53 415.317676,53 C419.148691,53 422.308826,55.6808904 422.761935,59.1422696 C423.097472,59.0491126 423.451838,59 423.817676,59 C426.026815,59 427.817676,60.790861 427.817676,63 C427.817676,63.0924298 427.814541,63.1841273 427.808372,63.2749921 C428.103238,63.0998664 428.448795,63 428.817676,63 C429.922246,63 430.817676,63.8954305 430.817676,65 C430.817676,66.1045695 429.922246,67 428.817676,67 L428.817676,67 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.2%",
    y: "-39.3%",
    width: "132.4%",
    height: "178.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "234.798672%",
    x2: "50%",
    y2: "60.9872109%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "51.5155788%",
    fx: "48.9155431%",
    fy: "51.5155788%",
    r: "47.6580123%",
    gradientTransform: "translate(0.489155,0.515156),scale(0.112245,1.000000),rotate(90.000000),scale(1.000000,9.340697),translate(-0.489155,-0.515156)",
    id: "radialGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50%",
    fx: "48.9155431%",
    fy: "50%",
    r: "49.173591%",
    gradientTransform: "translate(0.489155,0.500000),scale(0.148148,1.000000),rotate(90.000000),scale(1.000000,6.549158),translate(-0.489155,-0.500000)",
    id: "radialGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.3463739%",
    y1: "-17.6846596%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-15",
    cx: 132,
    cy: 163.482364,
    r: 38
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.3%",
    y: "-3.3%",
    width: "106.6%",
    height: "106.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50%",
    fx: "48.9155431%",
    fy: "50%",
    r: "49.173591%",
    gradientTransform: "translate(0.489155,0.500000),scale(0.080382,1.000000),rotate(90.000000),scale(1.000000,13.366712),translate(-0.489155,-0.500000)",
    id: "radialGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.8958899%",
    y1: "35.5406621%",
    x2: "27.6520041%",
    y2: "71.7686607%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.692059,145.635724 C252.333726,145.635724 252.858726,146.160724 252.858726,146.802391 L252.858726,146.802391 L252.858726,148.351724 C253.926226,148.627057 254.933059,149.047057 255.859392,149.594224 L255.859392,149.594224 L256.953726,148.498724 C257.407559,148.044891 258.150726,148.044891 258.604559,148.498724 L258.604559,148.498724 L261.079059,150.973224 C261.532892,151.427057 261.532892,152.170224 261.079059,152.624057 L261.079059,152.624057 L259.983559,153.718391 C260.530726,154.644724 260.950726,155.651557 261.226059,156.719057 L261.226059,156.719057 L262.775392,156.719057 C263.417059,156.719057 263.942059,157.244057 263.942059,157.885724 L263.942059,157.885724 L263.942059,161.385724 C263.942059,162.027391 263.417059,162.552391 262.775392,162.552391 L262.775392,162.552391 L261.226059,162.552391 C260.950726,163.619891 260.530726,164.626724 259.983559,165.553057 L259.983559,165.553057 L261.079059,166.647391 C261.532892,167.101224 261.532892,167.844391 261.079059,168.298224 L261.079059,168.298224 L258.604559,170.772724 C258.150726,171.226557 257.407559,171.226557 256.953726,170.772724 L256.953726,170.772724 L255.859392,169.677224 C254.933059,170.224391 253.926226,170.644391 252.858726,170.919724 L252.858726,170.919724 L252.858726,172.469057 C252.858726,173.110724 252.333726,173.635724 251.692059,173.635724 L251.692059,173.635724 L248.192059,173.635724 C247.550392,173.635724 247.025392,173.110724 247.025392,172.469057 L247.025392,172.469057 L247.025392,170.919724 C245.957892,170.644391 244.951059,170.224391 244.024726,169.677224 L244.024726,169.677224 L242.930392,170.772724 C242.476559,171.226557 241.733392,171.226557 241.279559,170.772724 L241.279559,170.772724 L238.805059,168.298224 C238.351226,167.844391 238.351226,167.101224 238.805059,166.647391 L238.805059,166.647391 L239.900559,165.553057 C239.353392,164.626724 238.933392,163.619891 238.658059,162.552391 L238.658059,162.552391 L237.108726,162.552391 C236.467059,162.552391 235.942059,162.027391 235.942059,161.385724 L235.942059,161.385724 L235.942059,157.885724 C235.942059,157.244057 236.467059,156.719057 237.108726,156.719057 L237.108726,156.719057 L238.658059,156.719057 C238.933392,155.651557 239.353392,154.644724 239.900559,153.718391 L239.900559,153.718391 L238.805059,152.624057 C238.351226,152.170224 238.351226,151.427057 238.805059,150.973224 L238.805059,150.973224 L241.279559,148.498724 C241.733392,148.044891 242.476559,148.044891 242.930392,148.498724 L242.930392,148.498724 L244.024726,149.594224 C244.951059,149.047057 245.957892,148.627057 247.025392,148.351724 L247.025392,148.351724 L247.025392,146.802391 C247.025392,146.160724 247.550392,145.635724 248.192059,145.635724 L248.192059,145.635724 Z M249.442059,154.635724 C246.956778,154.635724 244.942059,156.650443 244.942059,159.135724 C244.942059,161.621005 246.956778,163.635724 249.442059,163.635724 C251.92734,163.635724 253.942059,161.621005 253.942059,159.135724 C253.942059,156.650443 251.92734,154.635724 249.442059,154.635724 Z",
    id: "path-20"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.1%",
    y: "-7.1%",
    width: "114.3%",
    height: "114.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-21"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.437854,180.685624 C223.537854,180.685624 224.437854,181.585624 224.437854,182.685624 L224.437854,182.685624 L224.437854,185.341624 C226.267854,185.813624 227.993854,186.533624 229.581854,187.471624 L229.581854,187.471624 L231.457854,185.593624 C232.235854,184.815624 233.509854,184.815624 234.287854,185.593624 L234.287854,185.593624 L238.529854,189.835624 C239.307854,190.613624 239.307854,191.887624 238.529854,192.665624 L238.529854,192.665624 L236.651854,194.541624 C237.589854,196.129624 238.309854,197.855624 238.781854,199.685624 L238.781854,199.685624 L241.437854,199.685624 C242.537854,199.685624 243.437854,200.585624 243.437854,201.685624 L243.437854,201.685624 L243.437854,207.685624 C243.437854,208.785624 242.537854,209.685624 241.437854,209.685624 L241.437854,209.685624 L238.781854,209.685624 C238.309854,211.515624 237.589854,213.241624 236.651854,214.829624 L236.651854,214.829624 L238.529854,216.705624 C239.307854,217.483624 239.307854,218.757624 238.529854,219.535624 L238.529854,219.535624 L234.287854,223.777624 C233.509854,224.555624 232.235854,224.555624 231.457854,223.777624 L231.457854,223.777624 L229.581854,221.899624 C227.993854,222.837624 226.267854,223.557624 224.437854,224.029624 L224.437854,224.029624 L224.437854,226.685624 C224.437854,227.785624 223.537854,228.685624 222.437854,228.685624 L222.437854,228.685624 L216.437854,228.685624 C215.337854,228.685624 214.437854,227.785624 214.437854,226.685624 L214.437854,226.685624 L214.437854,224.029624 C212.607854,223.557624 210.881854,222.837624 209.293854,221.899624 L209.293854,221.899624 L207.417854,223.777624 C206.639854,224.555624 205.365854,224.555624 204.587854,223.777624 L204.587854,223.777624 L200.345854,219.535624 C199.567854,218.757624 199.567854,217.483624 200.345854,216.705624 L200.345854,216.705624 L202.223854,214.829624 C201.285854,213.241624 200.565854,211.515624 200.093854,209.685624 L200.093854,209.685624 L197.437854,209.685624 C196.337854,209.685624 195.437854,208.785624 195.437854,207.685624 L195.437854,207.685624 L195.437854,201.685624 C195.437854,200.585624 196.337854,199.685624 197.437854,199.685624 L197.437854,199.685624 L200.093854,199.685624 C200.565854,197.855624 201.285854,196.129624 202.223854,194.541624 L202.223854,194.541624 L200.345854,192.665624 C199.567854,191.887624 199.567854,190.613624 200.345854,189.835624 L200.345854,189.835624 L204.587854,185.593624 C205.365854,184.815624 206.639854,184.815624 207.417854,185.593624 L207.417854,185.593624 L209.293854,187.471624 C210.881854,186.533624 212.607854,185.813624 214.437854,185.341624 L214.437854,185.341624 L214.437854,182.685624 C214.437854,181.585624 215.337854,180.685624 216.437854,180.685624 L216.437854,180.685624 Z M219.437854,196.685624 C215.019576,196.685624 211.437854,200.267346 211.437854,204.685624 C211.437854,209.103902 215.019576,212.685624 219.437854,212.685624 C223.856132,212.685624 227.437854,209.103902 227.437854,204.685624 C227.437854,200.267346 223.856132,196.685624 219.437854,196.685624 Z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.5%",
    y: "-7.3%",
    width: "127.1%",
    height: "129.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-23"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.028721,156.612202 L267.171192,169.04947 C276.0696,171.132021 282.587372,178.748137 283.270232,187.861445 C283.921272,196.550098 277.873643,204.314969 269.290081,205.8113 L211.889768,215.817619 C195.541097,218.667604 179.977513,207.724758 177.127528,191.376087 C176.77078,189.329635 176.627206,187.251704 176.699111,185.175634 C177.280582,168.387102 191.361751,155.248684 208.150283,155.830155 C210.130557,155.898742 212.099392,156.160669 214.028721,156.612202 Z",
    id: "path-24"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "2.9%",
    width: "109.8%",
    height: "99.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-25"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.423233696   0 0 0 0 0.423233696   0 0 0 0 0.423233696  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 109,
    height: 74,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.625,158 C316.320833,158 317.708333,159.3875 317.708333,161.083333 L317.708333,161.083333 L317.708333,165.178 C320.529583,165.905667 323.1905,167.015667 325.638667,168.46175 L325.638667,168.46175 L328.530833,165.5665 C329.73025,164.367083 331.694333,164.367083 332.89375,165.5665 L332.89375,165.5665 L339.4335,172.10625 C340.632917,173.305667 340.632917,175.26975 339.4335,176.469167 L339.4335,176.469167 L336.53825,179.361333 C337.984333,181.8095 339.094333,184.470417 339.822,187.291667 L339.822,187.291667 L343.916667,187.291667 C345.6125,187.291667 347,188.679167 347,190.375 L347,190.375 L347,199.625 C347,201.320833 345.6125,202.708333 343.916667,202.708333 L343.916667,202.708333 L339.822,202.708333 C339.094333,205.529583 337.984333,208.1905 336.53825,210.638667 L336.53825,210.638667 L339.4335,213.530833 C340.632917,214.73025 340.632917,216.694333 339.4335,217.89375 L339.4335,217.89375 L332.89375,224.4335 C331.694333,225.632917 329.73025,225.632917 328.530833,224.4335 L328.530833,224.4335 L325.638667,221.53825 C323.1905,222.984333 320.529583,224.094333 317.708333,224.822 L317.708333,224.822 L317.708333,228.916667 C317.708333,230.6125 316.320833,232 314.625,232 L314.625,232 L305.375,232 C303.679167,232 302.291667,230.6125 302.291667,228.916667 L302.291667,228.916667 L302.291667,224.822 C299.470417,224.094333 296.8095,222.984333 294.361333,221.53825 L294.361333,221.53825 L291.469167,224.4335 C290.26975,225.632917 288.305667,225.632917 287.10625,224.4335 L287.10625,224.4335 L280.5665,217.89375 C279.367083,216.694333 279.367083,214.73025 280.5665,213.530833 L280.5665,213.530833 L283.46175,210.638667 C282.015667,208.1905 280.905667,205.529583 280.178,202.708333 L280.178,202.708333 L276.083333,202.708333 C274.3875,202.708333 273,201.320833 273,199.625 L273,199.625 L273,190.375 C273,188.679167 274.3875,187.291667 276.083333,187.291667 L276.083333,187.291667 L280.178,187.291667 C280.905667,184.470417 282.015667,181.8095 283.46175,179.361333 L283.46175,179.361333 L280.5665,176.469167 C279.367083,175.26975 279.367083,173.305667 280.5665,172.10625 L280.5665,172.10625 L287.10625,165.5665 C288.305667,164.367083 290.26975,164.367083 291.469167,165.5665 L291.469167,165.5665 L294.361333,168.46175 C296.8095,167.015667 299.470417,165.905667 302.291667,165.178 L302.291667,165.178 L302.291667,161.083333 C302.291667,159.3875 303.679167,158 305.375,158 L305.375,158 Z M309.5,182 C302.596441,182 297,187.596441 297,194.5 C297,201.403559 302.596441,207 309.5,207 C316.403559,207 322,201.403559 322,194.5 C322,187.596441 316.403559,182 309.5,182 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.8%",
    y: "-4.7%",
    width: "117.6%",
    height: "118.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-28"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50%",
    fx: "48.9155431%",
    fy: "50%",
    r: "49.173591%",
    gradientTransform: "translate(0.489155,0.500000),scale(0.140351,1.000000),rotate(90.000000),scale(1.000000,6.261852),translate(-0.489155,-0.500000)",
    id: "radialGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M503.63479,148.477763 C507.456298,155.020976 503.63479,165.842443 487.329689,172.133994 C485.036784,173.140642 485.036784,177.670558 478.158069,176.915572 C473.57226,176.412248 476.294944,165.757966 486.326124,144.952727 C495.317563,142.940609 501.087118,144.115621 503.63479,148.477763 Z M499.990627,151.138655 C497.875067,148.262982 491.151197,148.729425 489.622594,149.987735 C488.093991,151.246045 483.508181,166.597429 488.858292,166.597429 C495.227472,165.590781 502.106187,154.014327 499.990627,151.138655 Z",
    id: "path-30"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.1%",
    y: "-10.6%",
    width: "124.1%",
    height: "121.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-31"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "75.4740169%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "47.919324%",
    x2: "100%",
    y2: "47.919324%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "40.463396%",
    y2: "21.5777229%",
    id: "linearGradient-34"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-17.8%",
    y: "-14.3%",
    width: "135.6%",
    height: "128.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-35"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.5617232%",
    y1: "0%",
    x2: "62.1942748%",
    y2: "100%",
    id: "linearGradient-36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-37",
    cx: 387,
    cy: 215.7894,
    rx: 1.74326923,
    ry: 1.7228145
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-57.4%",
    y: "-58.0%",
    width: "214.7%",
    height: "216.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-38"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.9973917%",
    y1: "100%",
    x2: "39.3363291%",
    y2: "0%",
    id: "linearGradient-39"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.078113,1.000000),rotate(90.000000),scale(1.000000,13.555189),translate(-0.489155,-0.509384)",
    id: "radialGradient-40"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.6875,241 C390.489583,241 391.145833,241.65625 391.145833,242.458333 L391.145833,242.458333 L391.145833,244.395 C392.480208,244.739167 393.73875,245.264167 394.896667,245.948125 L394.896667,245.948125 L396.264583,244.57875 C396.831875,244.011458 397.760833,244.011458 398.328125,244.57875 L398.328125,244.57875 L401.42125,247.671875 C401.988542,248.239167 401.988542,249.168125 401.42125,249.735417 L401.42125,249.735417 L400.051875,251.103333 C400.735833,252.26125 401.260833,253.519792 401.605,254.854167 L401.605,254.854167 L403.541667,254.854167 C404.34375,254.854167 405,255.510417 405,256.3125 L405,256.3125 L405,260.6875 C405,261.489583 404.34375,262.145833 403.541667,262.145833 L403.541667,262.145833 L401.605,262.145833 C401.260833,263.480208 400.735833,264.73875 400.051875,265.896667 L400.051875,265.896667 L401.42125,267.264583 C401.988542,267.831875 401.988542,268.760833 401.42125,269.328125 L401.42125,269.328125 L398.328125,272.42125 C397.760833,272.988542 396.831875,272.988542 396.264583,272.42125 L396.264583,272.42125 L394.896667,271.051875 C393.73875,271.735833 392.480208,272.260833 391.145833,272.605 L391.145833,272.605 L391.145833,274.541667 C391.145833,275.34375 390.489583,276 389.6875,276 L389.6875,276 L385.3125,276 C384.510417,276 383.854167,275.34375 383.854167,274.541667 L383.854167,274.541667 L383.854167,272.605 C382.519792,272.260833 381.26125,271.735833 380.103333,271.051875 L380.103333,271.051875 L378.735417,272.42125 C378.168125,272.988542 377.239167,272.988542 376.671875,272.42125 L376.671875,272.42125 L373.57875,269.328125 C373.011458,268.760833 373.011458,267.831875 373.57875,267.264583 L373.57875,267.264583 L374.948125,265.896667 C374.264167,264.73875 373.739167,263.480208 373.395,262.145833 L373.395,262.145833 L371.458333,262.145833 C370.65625,262.145833 370,261.489583 370,260.6875 L370,260.6875 L370,256.3125 C370,255.510417 370.65625,254.854167 371.458333,254.854167 L371.458333,254.854167 L373.395,254.854167 C373.739167,253.519792 374.264167,252.26125 374.948125,251.103333 L374.948125,251.103333 L373.57875,249.735417 C373.011458,249.168125 373.011458,248.239167 373.57875,247.671875 L373.57875,247.671875 L376.671875,244.57875 C377.239167,244.011458 378.168125,244.011458 378.735417,244.57875 L378.735417,244.57875 L380.103333,245.948125 C381.26125,245.264167 382.519792,244.739167 383.854167,244.395 L383.854167,244.395 L383.854167,242.458333 C383.854167,241.65625 384.510417,241 385.3125,241 L385.3125,241 Z M387.5,252.666667 C384.278339,252.666667 381.666667,255.278339 381.666667,258.5 C381.666667,261.721661 384.278339,264.333333 387.5,264.333333 C390.721661,264.333333 393.333333,261.721661 393.333333,258.5 C393.333333,255.278339 390.721661,252.666667 387.5,252.666667 Z",
    id: "path-41"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.2%",
    y: "-10.0%",
    width: "120.4%",
    height: "131.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-42"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.306416,176.197974 L406.219982,197.177585 C419.035077,199.841803 428.575824,210.611022 429.675998,223.65381 C430.720396,236.035355 422.006111,247.114041 409.726951,249.015528 L307.893516,264.784926 C283.990108,268.486484 261.611861,252.109648 257.910303,228.20624 C257.479675,225.425388 257.318057,222.609505 257.42769,219.797645 L257.676114,213.426151 C258.528191,191.57228 276.935,174.546962 298.788871,175.39904 C300.979757,175.484462 303.159765,175.751692 305.306416,176.197974 Z",
    id: "path-43"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.5%",
    y: "3.0%",
    width: "105.2%",
    height: "96.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-44"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.8,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.423233696   0 0 0 0 0.423233696   0 0 0 0 0.423233696  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-45",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 176.174046,
    height: 106.245801,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-46",
    cx: 110,
    cy: 68,
    r: 9
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-33.3%",
    width: "233.3%",
    height: "222.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-47"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-48",
    cx: 486,
    cy: 250,
    r: 20
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.0%",
    y: "-15.0%",
    width: "160.0%",
    height: "155.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-49"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-50",
    cx: 103,
    cy: 262,
    r: 14
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.4%",
    y: "-21.4%",
    width: "185.7%",
    height: "178.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-51"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-52",
    cx: 466,
    cy: 51,
    r: 13
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.1%",
    y: "-23.1%",
    width: "192.3%",
    height: "184.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-53"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-54",
    cx: 17.8176762,
    cy: 124,
    r: 9
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-33.3%",
    width: "233.3%",
    height: "222.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-55"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(-26.000000, -27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.895465,58.6837803 C475.814781,57.9134039 478.84548,59.636667 479.627708,62.511751 L479.627708,62.511751 L481.511157,69.4491585 C486.577122,69.3995658 491.67196,70.0473767 496.673587,71.4168866 L496.673587,71.4168866 L500.32147,65.1943012 C501.832264,62.6171762 505.209365,61.7259953 507.826138,63.2138991 L507.826138,63.2138991 L522.099506,71.3296336 C524.716219,72.8176418 525.62111,76.1435745 524.110316,78.7206994 L524.110316,78.7206994 L520.462433,84.9432849 C524.167524,88.5244366 527.284595,92.5459384 529.773968,96.8915152 L529.773968,96.8915152 L536.816094,95.0292123 C539.73541,94.2588359 542.766109,95.982099 543.548337,98.857183 L543.548337,98.857183 L547.813392,114.533412 C548.595621,117.408496 546.845846,120.393275 543.92653,121.163652 L543.92653,121.163652 L536.882393,123.018564 C536.932749,128.007771 536.274971,133.025415 534.884392,137.95126 L534.884392,137.95126 L541.20271,141.543872 C543.819483,143.031775 544.724374,146.357708 543.213683,148.934893 L543.213683,148.934893 L534.972881,162.991878 C533.462087,165.569003 530.084986,166.460184 527.468213,164.972281 L527.468213,164.972281 L521.149895,161.379669 C517.513649,165.028622 513.430278,168.098465 509.017846,170.55012 L509.017846,170.55012 L510.9088,177.485547 C511.691028,180.360631 509.941253,183.34541 507.021937,184.115787 L507.021937,184.115787 L491.104535,188.31622 C488.185219,189.086596 485.15452,187.363333 484.372292,184.488249 L484.372292,184.488249 L482.488843,177.550841 C477.422878,177.600434 472.32804,176.952623 467.326413,175.583113 L467.326413,175.583113 L463.67853,181.805699 C462.167736,184.382824 458.790635,185.274005 456.173862,183.786101 L456.173862,183.786101 L441.900494,175.670366 C439.283781,174.182358 438.37889,170.856426 439.889684,168.279301 L439.889684,168.279301 L443.537567,162.056715 C439.832476,158.475563 436.715405,154.454062 434.226032,150.108485 L434.226032,150.108485 L427.183906,151.970788 C424.26459,152.741164 421.233891,151.017901 420.451663,148.142817 L420.451663,148.142817 L416.186608,132.466588 C415.404379,129.591504 417.154154,126.606725 420.07347,125.836348 L420.07347,125.836348 L427.117607,123.981436 C427.067251,118.992229 427.725029,113.974585 429.115608,109.04874 L429.115608,109.04874 L422.79729,105.456128 C420.180517,103.968225 419.275626,100.642292 420.786317,98.0651072 L420.786317,98.0651072 L429.027119,84.0081216 C430.537913,81.4309966 433.915014,80.5398157 436.531787,82.0277195 L436.531787,82.0277195 L442.850105,85.6203308 C446.486351,81.971378 450.569722,78.9015353 454.982154,76.4498801 L454.982154,76.4498801 L453.0912,69.514453 C452.308972,66.639369 454.058747,63.6545897 456.978063,62.8842133 L456.978063,62.8842133 Z M462.968923,112.678881 C456.900641,123.030204 460.501829,136.266388 471.012403,142.242727 C481.522976,148.219066 494.962794,144.672441 501.031077,134.321119 C507.099359,123.969796 503.498171,110.733612 492.987597,104.757273 C482.477024,98.7809341 469.037206,102.327559 462.968923,112.678881 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.692676,81 C361.680176,81 364.942676,84.2625 364.942676,88.25 L364.942676,88.25 L364.942676,97.878 C371.576426,99.589 377.833176,102.199 383.589676,105.59925 L383.589676,105.59925 L390.390176,98.7915 C393.210426,95.97125 397.828676,95.97125 400.648926,98.7915 L400.648926,98.7915 L416.026176,114.16875 C418.846426,116.989 418.846426,121.60725 416.026176,124.4275 L416.026176,124.4275 L409.218426,131.228 C412.618676,136.9845 415.228676,143.24125 416.939676,149.875 L416.939676,149.875 L426.567676,149.875 C430.555176,149.875 433.817676,153.1375 433.817676,157.125 L433.817676,157.125 L433.817676,178.875 C433.817676,182.8625 430.555176,186.125 426.567676,186.125 L426.567676,186.125 L416.939676,186.125 C415.228676,192.75875 412.618676,199.0155 409.218426,204.772 L409.218426,204.772 L416.026176,211.5725 C418.846426,214.39275 418.846426,219.011 416.026176,221.83125 L416.026176,221.83125 L400.648926,237.2085 C397.828676,240.02875 393.210426,240.02875 390.390176,237.2085 L390.390176,237.2085 L383.589676,230.40075 C377.833176,233.801 371.576426,236.411 364.942676,238.122 L364.942676,238.122 L364.942676,247.75 C364.942676,251.7375 361.680176,255 357.692676,255 L357.692676,255 L335.942676,255 C331.955176,255 328.692676,251.7375 328.692676,247.75 L328.692676,247.75 L328.692676,238.122 C322.058926,236.411 315.802176,233.801 310.045676,230.40075 L310.045676,230.40075 L303.245176,237.2085 C300.424926,240.02875 295.806676,240.02875 292.986426,237.2085 L292.986426,237.2085 L277.609176,221.83125 C274.788926,219.011 274.788926,214.39275 277.609176,211.5725 L277.609176,211.5725 L284.416926,204.772 C281.016676,199.0155 278.406676,192.75875 276.695676,186.125 L276.695676,186.125 L267.067676,186.125 C263.080176,186.125 259.817676,182.8625 259.817676,178.875 L259.817676,178.875 L259.817676,157.125 C259.817676,153.1375 263.080176,149.875 267.067676,149.875 L267.067676,149.875 L276.695676,149.875 C278.406676,143.24125 281.016676,136.9845 284.416926,131.228 L284.416926,131.228 L277.609176,124.4275 C274.788926,121.60725 274.788926,116.989 277.609176,114.16875 L277.609176,114.16875 L292.986426,98.7915 C295.806676,95.97125 300.424926,95.97125 303.245176,98.7915 L303.245176,98.7915 L310.045676,105.59925 C315.802176,102.199 322.058926,99.589 328.692676,97.878 L328.692676,97.878 L328.692676,88.25 C328.692676,84.2625 331.955176,81 335.942676,81 L335.942676,81 Z M346.817676,138 C330.801418,138 317.817676,150.983742 317.817676,167 C317.817676,183.016258 330.801418,196 346.817676,196 C362.833934,196 375.817676,183.016258 375.817676,167 C375.817676,150.983742 362.833934,138 346.817676,138 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.057324,81 C216.044824,81 219.307324,84.2625 219.307324,88.25 L219.307324,88.25 L219.307324,97.878 C225.941074,99.589 232.197824,102.199 237.954324,105.59925 L237.954324,105.59925 L244.754824,98.7915 C247.575074,95.97125 252.193324,95.97125 255.013574,98.7915 L255.013574,98.7915 L270.390824,114.16875 C273.211074,116.989 273.211074,121.60725 270.390824,124.4275 L270.390824,124.4275 L263.583074,131.228 C266.983324,136.9845 269.593324,143.24125 271.304324,149.875 L271.304324,149.875 L280.932324,149.875 C284.919824,149.875 288.182324,153.1375 288.182324,157.125 L288.182324,157.125 L288.182324,178.875 C288.182324,182.8625 284.919824,186.125 280.932324,186.125 L280.932324,186.125 L271.304324,186.125 C269.593324,192.75875 266.983324,199.0155 263.583074,204.772 L263.583074,204.772 L270.390824,211.5725 C273.211074,214.39275 273.211074,219.011 270.390824,221.83125 L270.390824,221.83125 L255.013574,237.2085 C252.193324,240.02875 247.575074,240.02875 244.754824,237.2085 L244.754824,237.2085 L237.954324,230.40075 C232.197824,233.801 225.941074,236.411 219.307324,238.122 L219.307324,238.122 L219.307324,247.75 C219.307324,251.7375 216.044824,255 212.057324,255 L212.057324,255 L190.307324,255 C186.319824,255 183.057324,251.7375 183.057324,247.75 L183.057324,247.75 L183.057324,238.122 C176.423574,236.411 170.166824,233.801 164.410324,230.40075 L164.410324,230.40075 L157.609824,237.2085 C154.789574,240.02875 150.171324,240.02875 147.351074,237.2085 L147.351074,237.2085 L131.973824,221.83125 C129.153574,219.011 129.153574,214.39275 131.973824,211.5725 L131.973824,211.5725 L138.781574,204.772 C135.381324,199.0155 132.771324,192.75875 131.060324,186.125 L131.060324,186.125 L121.432324,186.125 C117.444824,186.125 114.182324,182.8625 114.182324,178.875 L114.182324,178.875 L114.182324,157.125 C114.182324,153.1375 117.444824,149.875 121.432324,149.875 L121.432324,149.875 L131.060324,149.875 C132.771324,143.24125 135.381324,136.9845 138.781574,131.228 L138.781574,131.228 L131.973824,124.4275 C129.153574,121.60725 129.153574,116.989 131.973824,114.16875 L131.973824,114.16875 L147.351074,98.7915 C150.171324,95.97125 154.789574,95.97125 157.609824,98.7915 L157.609824,98.7915 L164.410324,105.59925 C170.166824,102.199 176.423574,99.589 183.057324,97.878 L183.057324,97.878 L183.057324,88.25 C183.057324,84.2625 186.319824,81 190.307324,81 L190.307324,81 Z M201.182324,138 C185.166066,138 172.182324,150.983742 172.182324,167 C172.182324,183.016258 185.166066,196 201.182324,196 C217.198582,196 230.182324,183.016258 230.182324,167 C230.182324,150.983742 217.198582,138 201.182324,138 Z",
    id: "Combined-Shape-Copy-3",
    fill: "url(#linearGradient-2)",
    opacity: 0.5,
    transform: "translate(201.000000, 167.500000) scale(-1, 1) translate(-201.000000, -167.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8954647,58.6837803 C59.8147807,57.9134039 62.8454797,59.636667 63.6277081,62.511751 L63.6277081,62.511751 L65.5111571,69.4491585 C70.5771217,69.3995658 75.6719602,70.0473767 80.6735873,71.4168866 L80.6735873,71.4168866 L84.3214696,65.1943012 C85.8322642,62.6171762 89.2093651,61.7259953 91.8261381,63.2138991 L91.8261381,63.2138991 L106.099506,71.3296336 C108.716219,72.8176418 109.62111,76.1435745 108.110316,78.7206994 L108.110316,78.7206994 L104.462433,84.9432849 C108.167524,88.5244366 111.284595,92.5459384 113.773968,96.8915152 L113.773968,96.8915152 L120.816094,95.0292123 C123.73541,94.2588359 126.766109,95.982099 127.548337,98.857183 L127.548337,98.857183 L131.813392,114.533412 C132.595621,117.408496 130.845846,120.393275 127.92653,121.163652 L127.92653,121.163652 L120.882393,123.018564 C120.932749,128.007771 120.274971,133.025415 118.884392,137.95126 L118.884392,137.95126 L125.20271,141.543872 C127.819483,143.031775 128.724374,146.357708 127.213683,148.934893 L127.213683,148.934893 L118.972881,162.991878 C117.462087,165.569003 114.084986,166.460184 111.468213,164.972281 L111.468213,164.972281 L105.149895,161.379669 C101.513649,165.028622 97.4302779,168.098465 93.0178461,170.55012 L93.0178461,170.55012 L94.9087998,177.485547 C95.6910282,180.360631 93.9412533,183.34541 91.0219373,184.115787 L91.0219373,184.115787 L75.1045353,188.31622 C72.1852193,189.086596 69.1545203,187.363333 68.3722919,184.488249 L68.3722919,184.488249 L66.4888429,177.550841 C61.4228783,177.600434 56.3280398,176.952623 51.3264127,175.583113 L51.3264127,175.583113 L47.6785304,181.805699 C46.1677358,184.382824 42.7906349,185.274005 40.1738619,183.786101 L40.1738619,183.786101 L25.900494,175.670366 C23.2837812,174.182358 22.3788898,170.856426 23.8896844,168.279301 L23.8896844,168.279301 L27.5375667,162.056715 C23.8324761,158.475563 20.7154051,154.454062 18.2260321,150.108485 L18.2260321,150.108485 L11.1839061,151.970788 C8.26459006,152.741164 5.23389108,151.017901 4.4516627,148.142817 L4.4516627,148.142817 L0.186607703,132.466588 C-0.595620677,129.591504 1.15415419,126.606725 4.07347025,125.836348 L4.07347025,125.836348 L11.1176071,123.981436 C11.0672514,118.992229 11.7250286,113.974585 13.115608,109.04874 L13.115608,109.04874 L6.79729048,105.456128 C4.18051742,103.968225 3.27562598,100.642292 4.78631701,98.0651072 L4.78631701,98.0651072 L13.0271186,84.0081216 C14.5379132,81.4309966 17.9150141,80.5398157 20.5317871,82.0277195 L20.5317871,82.0277195 L26.8501046,85.6203308 C30.486351,81.971378 34.5697221,78.9015353 38.9821539,76.4498801 L38.9821539,76.4498801 L37.0912002,69.514453 C36.3089718,66.639369 38.0587467,63.6545897 40.9780627,62.8842133 L40.9780627,62.8842133 Z M46.9689232,112.678881 C40.9006408,123.030204 44.5018292,136.266388 55.0124027,142.242727 C65.5229762,148.219066 78.9627944,144.672441 85.0310768,134.321119 C91.0993592,123.969796 87.4981708,110.733612 76.9875973,104.757273 C66.4770238,98.7809341 53.0372056,102.327559 46.9689232,112.678881 Z",
    id: "Combined-Shape-Copy-4",
    fill: "url(#linearGradient-1)",
    opacity: 0.5,
    transform: "translate(66.000000, 123.500000) scale(-1, 1) translate(-66.000000, -123.500000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy",
    transform: "translate(170.317676, 50.500000) scale(-1, -1) rotate(-180.000000) translate(-170.317676, -50.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-2",
    transform: "translate(225.817676, 44.000000) scale(-1, 1) rotate(-360.000000) translate(-225.817676, -44.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-5",
    transform: "translate(413.817676, 60.000000) scale(-1, 1) rotate(-360.000000) translate(-413.817676, -60.000000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#575756",
    transform: "translate(99.692236, 134.718633) rotate(-45.000000) translate(-99.692236, -134.718633) ",
    x: 97.3191013,
    y: 131.557342,
    width: 4.74626866,
    height: 6.32258065
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.932835,122.412435 L95.410447,122.412435 C102.590149,122.412435 108.410447,128.232734 108.410447,135.412435 L108.410447,135.847919 L108.410447,135.847919 L79.932835,135.847919 L79.932835,135.412435 C79.932835,128.232734 85.7531333,122.412435 92.932835,122.412435 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    transform: "translate(94.171641, 129.130177) scale(-1, 1) rotate(45.000000) translate(-94.171641, -129.130177) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#575756",
    transform: "translate(164.051788, 134.718633) scale(-1, 1) rotate(-45.000000) translate(-164.051788, -134.718633) ",
    x: 161.678653,
    y: 131.557342,
    width: 4.74626866,
    height: 6.32258065
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.333576,122.412435 L170.811188,122.412435 C177.99089,122.412435 183.811188,128.232734 183.811188,135.412435 L183.811188,135.847919 L183.811188,135.847919 L155.333576,135.847919 L155.333576,135.412435 C155.333576,128.232734 161.153875,122.412435 168.333576,122.412435 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    transform: "translate(169.572382, 129.130177) rotate(45.000000) translate(-169.572382, -129.130177) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-12)",
    cx: 132,
    cy: 205.982364,
    rx: 49,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-13)",
    opacity: 0.5,
    cx: 109,
    cy: 207.482364,
    rx: 27,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.108749,198.046519 L111.434218,198.04363 L111.430607,205.950467 C111.429809,207.697664 110.013625,209.113848 108.266428,209.114646 C106.521293,209.115443 105.105935,207.701377 105.105138,205.956242 C105.105137,205.95528 105.105137,205.954318 105.105138,205.953356 L105.108749,198.046519 L105.108749,198.046519 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-14)",
    transform: "translate(108.269678, 203.579138) rotate(-315.000000) translate(-108.269678, -203.579138) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.569393,198.046519 L158.894863,198.04363 L158.891252,205.950467 C158.890454,207.697664 157.47427,209.113848 155.727072,209.114646 C153.981937,209.115443 152.566579,207.701377 152.565782,205.956242 C152.565782,205.95528 152.565782,205.954318 152.565782,205.953356 L152.569393,198.046519 L152.569393,198.046519 Z",
    id: "Rectangle",
    fill: "#D9D9D9",
    transform: "translate(155.730322, 203.579138) scale(-1, 1) rotate(-315.000000) translate(-155.730322, -203.579138) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D9D9D9",
    cx: 132.5,
    cy: 162.982364,
    r: 42.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-45",
    stroke: "#FF520B",
    strokeWidth: 4,
    strokeLinecap: "round",
    points: "117.332012 176.482364 132 163.099385 116 139.482364"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#575756",
    cx: 132.5,
    cy: 162.982364,
    r: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-17)",
    opacity: 0.5,
    cx: 288,
    cy: 277.726315,
    rx: 115,
    ry: 9.24395112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.254,104 L395.746,104 C399.752274,104 403,107.247726 403,111.254 L403,250.924479 C403,253.595328 400.834849,255.760479 398.164,255.760479 L177.836,255.760479 C175.165151,255.760479 173,253.595328 173,250.924479 L173,111.254 C173,107.247726 176.247726,104 180.254,104 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-18)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(249.942059, 159.635724) rotate(17.000000) translate(-249.942059, -159.635724) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-21)",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-19)",
    fillRule: "evenodd",
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-6",
    transform: "translate(219.437854, 204.685624) rotate(17.000000) translate(-219.437854, -204.685624) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-23)",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-19)",
    fillRule: "evenodd",
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(229.917615, 185.175634) rotate(-58.000000) translate(-229.917615, -185.175634) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-25)",
    xlinkHref: "#path-24"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#D9D9D9",
    mask: "url(#mask-26)",
    strokeWidth: 8.4,
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-7"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-28)",
    xlinkHref: "#path-27"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-19)",
    fillRule: "evenodd",
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.836,103.482364 L398.164,103.482364 C400.834849,103.482364 403,105.647515 403,108.318364 L403,125.254819 L403,125.254819 L173,125.254819 L173,108.318364 C173,105.647515 175.165151,103.482364 177.836,103.482364 Z",
    id: "Rectangle",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9D9D9",
    x: 263.789474,
    y: 109.530268,
    width: 133.157895,
    height: 9.67664671,
    rx: 4.836
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 205.196507,
    cy: 114.368592,
    rx: 3.61496722,
    ry: 3.62874251
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2CB5D6",
    cx: 194.772862,
    cy: 114.368592,
    rx: 3.61496722,
    ry: 3.62874251
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF520B",
    cx: 184.349217,
    cy: 114.683279,
    rx: 3.61496722,
    ry: 3.62874251
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.530169,160.151241 C466.759252,158.759084 465.130199,157.104164 463.031057,156.617627 C460.931915,156.13109 460.33642,157.078807 458.517164,156.657142 C459.767382,157.882259 466.246786,161.705924 467.530169,160.151241 Z",
    id: "Path-26",
    fill: "#D9D9D9",
    transform: "translate(463.023666, 158.496105) rotate(39.000000) translate(-463.023666, -158.496105) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.743332,159.968144 C466.233762,159.503028 465.505804,157.95264 466.233762,156.402253 C466.719067,155.368661 467.641146,154.335069 469,153.301478 C468.805878,154.386749 468.708817,155.213622 468.708817,155.782098 C468.708817,156.634811 468.344838,159.580547 466.743332,159.968144 Z",
    id: "Path-27",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-29)",
    cx: 452.5,
    cy: 188,
    rx: 28.5,
    ry: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-30"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-31)",
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.761319,134.36855 C433.570484,132.789517 442.316711,132 453,132 C463.683288,132 472.429515,132.789516 479.23868,134.368549 L479.238681,134.368548 C483.839968,135.435578 487.067185,139.576617 486.977858,144.299161 C486.414185,174.09972 475.088232,189 453,189 C430.911767,189 419.585814,174.099719 419.022142,144.299158 L419.022145,144.299157 C418.932819,139.576616 422.160034,135.435579 426.761319,134.36855 Z",
    id: "Path-23",
    fill: "url(#linearGradient-32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 452.5,
    cy: 138,
    rx: 30.5,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-33)",
    opacity: 0.200000003,
    transform: "translate(452.000000, 137.500000) rotate(-90.000000) translate(-452.000000, -137.500000) ",
    cx: 452,
    cy: 137.5,
    rx: 4,
    ry: 30.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.868531,147 L470.851803,150.278958 C471.06737,150.4208 471.219761,150.640482 471.277116,150.892074 L474.898506,166.777736 C475.021258,167.316206 474.684253,167.852234 474.145783,167.974987 C474.072863,167.99161 473.998309,168 473.923519,168 L462.676816,168 C462.210164,168 461.805549,167.677243 461.701829,167.222264 L458.073454,151.30596 C457.966824,150.838214 458.207394,150.36065 458.646729,150.16793 L465.868531,147 Z M465.868531,150.818182 C465.134102,150.818182 464.538729,151.530456 464.538729,152.409091 C464.538729,153.287726 465.134102,154 465.868531,154 C466.60296,154 467.198332,153.287726 467.198332,152.409091 C467.198332,151.530456 466.60296,150.818182 465.868531,150.818182 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-34)",
    filter: "url(#filter-35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.496121,147 L469.668338,149.850158 C469.87943,150.039819 470,150.310236 470,150.594016 L470,163 C470,163.552285 469.552285,164 469,164 L459,164 C458.447715,164 458,163.552285 458,163 L458,150.591438 C458,150.309157 458.119304,150.040025 458.328466,149.850464 L461.473684,147 L466.496121,147 Z M464,148.888889 C463.337258,148.888889 462.8,149.452678 462.8,150.148148 C462.8,150.843618 463.337258,151.407407 464,151.407407 C464.662742,151.407407 465.2,150.843618 465.2,150.148148 C465.2,149.452678 464.662742,148.888889 464,148.888889 Z",
    id: "Combined-Shape",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,140.764706 L461,140.5 C461,139.671573 461.671573,139 462.5,139 C463.328427,139 464,139.671573 464,140.5 L464,149 L464,149",
    id: "Path-25",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#62EBB9",
    cx: 386.246154,
    cy: 258.213707,
    r: 65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#62EBB9",
    cx: 386.246154,
    cy: 258.213707,
    r: 54
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.2,
    fill: "#62EBB9",
    cx: 386.246154,
    cy: 258.213707,
    rx: 42.2153846,
    ry: 42.2089552
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.25,
    fill: "#62EBB9",
    cx: 386.246154,
    cy: 258.213707,
    rx: 36.1846154,
    ry: 36.1791045
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.964835,212.232364 C362.591953,212.232364 359.857692,214.966625 359.857692,218.339507 L359.857692,296.580445 C359.857692,299.953327 362.591953,302.687588 365.964835,302.687588 L408.035165,302.687588 C411.408047,302.687588 414.142308,299.953327 414.142308,296.580445 L414.142308,218.339507 C414.142308,214.966625 411.408047,212.232364 408.035165,212.232364 L365.964835,212.232364 Z",
    id: "Rectangle",
    stroke: "url(#linearGradient-36)",
    strokeWidth: 1.5,
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.65,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-38)",
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.022802,214.927993 L374.041622,214.927993 C375.751208,214.927993 377.349039,215.777523 378.305099,217.194786 L378.733363,217.829644 C379.689422,219.246906 381.287253,220.096437 382.996839,220.096437 L391.003161,220.096437 C392.712747,220.096437 394.310578,219.246906 395.266637,217.829644 L395.694901,217.194786 C396.650961,215.777523 398.248792,214.927993 399.958378,214.927993 L407.977198,214.927993 C409.870746,214.927993 411.405769,216.463017 411.405769,218.356565 L411.405769,296.563388 C411.405769,298.456935 409.870746,299.991959 407.977198,299.991959 L366.022802,299.991959 C364.129254,299.991959 362.594231,298.456935 362.594231,296.563388 L362.594231,218.356565 C362.594231,216.463017 364.129254,214.927993 366.022802,214.927993 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-39)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-40)",
    cx: 386.246154,
    cy: 313.713707,
    rx: 48.2461538,
    ry: 3.76865672
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-42)",
    xlinkHref: "#path-41"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-19)",
    fillRule: "evenodd",
    xlinkHref: "#path-41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M459.729379,111.211877 C459.729379,72.5519441 428.165454,41.2118766 389.229379,41.2118766 C350.293304,41.2118766 318.729379,72.5519441 318.729379,111.211877",
    id: "Oval",
    stroke: "#575756",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(389.229379, 76.211877) rotate(-49.000000) translate(-389.229379, -76.211877) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.179453,200.661979 C179.745357,39.4886578 95.3210012,197.421239 23.1794526,156.654115",
    id: "Oval-Copy-11",
    stroke: "#575756",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(115.179453, 163.577096) rotate(-544.000000) translate(-115.179453, -163.577096) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#00F0B5",
    transform: "translate(184.186540, 236.270477) rotate(-184.000000) translate(-184.186540, -236.270477) ",
    cx: 184.18654,
    cy: 236.270477,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "#00F0B5",
    transform: "translate(211.000000, 147.000000) rotate(-184.000000) translate(-211.000000, -147.000000) ",
    cx: 211,
    cy: 147,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    fill: "#00F5B1",
    transform: "translate(403.000000, 292.000000) rotate(-184.000000) translate(-403.000000, -292.000000) ",
    cx: 403,
    cy: 292,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 481.275159,
    y1: 257.202383,
    x2: 400.814417,
    y2: 289.668812,
    id: "Path-4",
    stroke: "#00F0B5",
    strokeWidth: 2,
    transform: "translate(441.271269, 273.475747) rotate(-184.000000) translate(-441.271269, -273.475747) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#575756",
    transform: "translate(373.000000, 156.000000) rotate(-49.000000) translate(-373.000000, -156.000000) ",
    cx: 373,
    cy: 156,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#575756",
    transform: "translate(205.000000, 164.000000) rotate(-49.000000) translate(-205.000000, -164.000000) ",
    cx: 205,
    cy: 164,
    r: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeDasharray: "4.8,9.6",
    transform: "translate(343.443463, 219.797645) rotate(38.000000) translate(-343.443463, -219.797645) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-44)",
    xlinkHref: "#path-43"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#D9D9D9",
    mask: "url(#mask-45)",
    strokeWidth: 9.6,
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-47)",
    xlinkHref: "#path-46"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-49)",
    xlinkHref: "#path-48"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M482.285714,259 L474.309286,251.580614 C473.636686,250.954986 473.598607,249.902564 474.224236,249.229964 C474.251551,249.200597 474.27992,249.172229 474.309286,249.144914 C475.04748,248.458272 476.190401,248.457477 476.92955,249.143091 L482.285714,254.111324 L482.285714,254.111324 L495.067827,242.221864 C495.807477,241.533869 496.953495,241.535889 497.690714,242.226488 C498.365696,242.858784 498.400299,243.918541 497.768003,244.593523 C497.741742,244.621556 497.714525,244.648678 497.686399,244.674839 L482.285714,259 L482.285714,259 Z",
    id: "Path-Copy-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-51)",
    xlinkHref: "#path-50"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EBB9",
    fillRule: "evenodd",
    xlinkHref: "#path-50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-53)",
    xlinkHref: "#path-52"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-55)",
    xlinkHref: "#path-54"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-54"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#FFFFFF",
    cx: 466,
    cy: 51,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    fill: "#FFFFFF",
    cx: 17.8176762,
    cy: 124,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.5,
    y1: 262.5,
    x2: 184.18654,
    y2: 236.270477,
    id: "Path-2",
    stroke: "#62EBB9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.5,
    y1: 71.5,
    x2: 211,
    y2: 147,
    id: "Path-3",
    stroke: "#62EBB9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.428571,268 L94.9064286,263.053743 C94.4580285,262.652105 94.4201203,261.963013 94.8217582,261.514613 C94.8484089,261.484859 94.876675,261.456593 94.9064286,261.429942 C95.4225446,260.96765 96.2036539,260.967109 96.7204102,261.428685 L100.428571,264.740883 L100.428571,264.740883 L109.277847,256.814468 C109.794944,256.351298 110.578105,256.352674 111.093571,256.817658 C111.543559,257.223577 111.579284,257.917426 111.173366,258.367414 C111.147292,258.396318 111.119699,258.423814 111.090704,258.449785 L100.428571,268 L100.428571,268 Z",
    id: "Path-Copy-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.285714,72 L104.604286,68.7024952 C104.305352,68.4347366 104.28008,67.9753419 104.547839,67.6764085 C104.565606,67.6565728 104.58445,67.6377287 104.604286,67.6199616 C104.948363,67.3117669 105.469103,67.311406 105.813607,67.6191235 L108.285714,69.8272553 L108.285714,69.8272553 L114.185231,64.542979 C114.529963,64.2341984 115.05207,64.2351157 115.395714,64.5451056 C115.695706,64.8157179 115.719523,65.278284 115.44891,65.5782757 C115.431528,65.597545 115.413133,65.6158758 115.393803,65.6331901 L108.285714,72 L108.285714,72 Z",
    id: "Path-Copy-4",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404IllustrationSm);
export default __webpack_public_path__ + "static/media/404-illustration-sm.b977914e9c711431b68549c34675089a.svg";
export { ForwardRef as ReactComponent };